import React from 'react';

import Rating from '../rating';

import * as S from './styles';

import { Store } from '../../../../types';

type Props = {
  id: Store['id'];
  name: Store['name'];
  hasLogo: Store['hasLogo'];
  logoUrl?: string | null;
  logoWidth: number;
  featured: Store['featured'];
  pathname: Store['pathName'];
  rating: Store['userReviewSummary']['rating'];
  reviewCount: Store['userReviewSummary']['count'];
  renderMode: string;
};

const StoreCard = ({
  id,
  name,
  hasLogo,
  logoUrl,
  logoWidth,
  featured,
  pathname,
  rating,
  reviewCount,
  renderMode,
}: Props) => {
  const count = reviewCount && reviewCount > 500 ? '500+' : reviewCount;

  const highResolutionLogo = logoUrl
    ? { url: logoUrl, width: logoWidth }
    : null;

  return (
    <S.Store to={pathname} isExternal={renderMode === 'native'}>
      <S.Logo
        storeId={id}
        name={name}
        hasImage={Boolean(hasLogo)}
        featured={Boolean(featured)}
        logoUrl={highResolutionLogo?.url}
        width={highResolutionLogo?.width}
        showHighResolutionLogo={Boolean(highResolutionLogo)}
      />
      <Rating type="store" rating={rating || 0} /> <S.Count>({count})</S.Count>
    </S.Store>
  );
};

export default StoreCard;
